
export function isNullOrEmpty(value: string | undefined | null): boolean {
  return value == null || (typeof value === 'string' && value.trim() === '');
}

export function trimSlash(value: string): string {
  return value.replace(/(^\/+|\/+$)/g, '');
}

export function decodeAges(value: string): number[] {
  if (value == null || isNullOrEmpty(value)) return [];
  return value.trim().split(/(?:,| |:|;|-)+/).map(p => parseInt(p));
}

export function isString(value: string): boolean {
  return typeof value === 'string';
}

export function toNumber(value: any, defaultValue: number = 0): number {
  const result = Number(value);
  return isNaN(result) ? defaultValue : result;
}

export function coerceBooleanProperty(value: any): boolean {
  return value != null && `${value}` !== 'false';
}
